'use strict'

// "Extend Symbols" invitation card — the prominent CTA tile that
// replaces the old buried "Add your app" tile at the end of the launcher
// grid. Per the brief: "reposition Add your app from afterthought to
// invitation". Sits in the BUILD group alongside AppHeroCards and is
// styled distinctly (dashed outline, no fill) so it reads as a CTA, not
// "yet another app tile".
//
// Routes to /add-app on click — same destination as the legacy tile.
// No state shape needed (the copy is fixed) but lives in
// childrenAs:'state' position so its container can render uniformly
// with the rest of the BUILD row.
export const ExtendCard = {
  tag: 'button',
  type: 'button',
  flow: 'y',
  gap: 'A',
  round: 'radiusSheet',
  padding: 'C',
  textAlign: 'left',
  cursor: 'pointer',
  color: 'title',
  background: 'transparent',
  // KEPT — design-direction.md §8's sanctioned dashed CTA-tile stroke (this
  // file's own header comment). `borderColor` was `'separator'`, which is
  // NOT a registered design-system colour token (zero matches in
  // company/packages/brand/designSystem/color.js — same class of bug as the
  // `background: 'surface'` find in the tickets sweep): the shorthand's
  // color position fell through to CSS's invalid-value behavior instead of
  // the intended muted divider hue. Retokenized to `line`, the token every
  // sibling divider in this package actually uses.
  border: 'hairline dashed',
  borderColor: 'line',
  transition:
    '160ms defaultBezier background, 160ms defaultBezier border-color, 160ms defaultBezier transform',
  ':hover': { borderColor: 'title', background: 'hover', transform: 'translateY(-2px)' },

  onClick: (e, el) => el.router('/add-app', el.getRoot()),

  PlusTile: {
    width: 'D',
    height: 'D',
    minWidth: 'D',
    round: 'radiusCard',
    align: 'center center',
    background: 'overlay',
    color: 'green',
    Icon: { name: 'plus', boxSize: 'C' }
  },

  Title: {
    tag: 'span',
    fontSize: 'B',
    fontWeight: '700',
    color: 'title',
    letterSpacing: '-0.005em',
    text: '{{ workspace.extend.title | polyglot }}'
  },

  Caption: {
    tag: 'p',
    margin: '0',
    fontSize: 'A',
    lineHeight: '1.4',
    color: 'caption',
    text: '{{ workspace.extend.caption | polyglot }}'
  }
}
